import { OrderChannelName, OrderStatusName, PayStatusName, RefundStatusName } from '@/config/enums'
import dayjs from 'dayjs'

// 基础信息
export const BasicInfoFormItems = [
  { span: 6, type: 'dis-input', prop: 'orderCode', label: '订单编号' },
  {
    span: 6,
    type: 'dis-input',
    label: '订单状态',
    formatter: (data: any, { model }: any) => {
      return (OrderStatusName as any)[model.orderStatus] || '--'
    }
  },
  {
    span: 6,
    type: 'dis-input',
    label: '创建时间',
    formatter: (data: any, { model }: any) => {
      return model.createTime ? dayjs(model.createTime).format('YYYY-MM-DD HH:mm:ss') : '--'
    }
  },
  {
    span: 6,
    type: 'dis-input',
    label: '用户信息',
    formatter: (data: any, { model }: any) => {
      return model.mobile || model.userName || '--'
    }
  },
  {
    span: 6,
    type: 'dis-input',
    label: '订单渠道',
    formatter: (data: any, { model }: any) => {
      return (OrderChannelName as any)[model.orderChannel] || model.orderChannel || '--'
    }
  }
]

// 商品信息
export const ProductInfoFormItems = [
  {
    label: '',
    labelWidth: 0,
    type: 'edit-table',
    prop: 'productInfoData',
    noIndex: true,
    noPager: true,
    noOperation: true,
    autoHeight: true,
    border: true,
    showSummary: false,
    columns: [
      {
        prop: 'mainImageUrl',
        label: '商品图片',
        component: {
          formItemType: 'label-image',
          label: '查看照片',
        },
        minWidth: 120
      },
      { prop: 'productCode', label: '商品编号', minWidth: 180 },
      { prop: 'productName', label: '商品名称', minWidth: 150 },
      { prop: 'productSubName', label: '商品文案', minWidth: 150 },
      { prop: 'productSpec', label: '商品规格', minWidth: 150 },
      { prop: 'salePrice', label: '商品单价（元）', minWidth: 100 },
      { prop: 'buyQuantity', label: '购买数量', minWidth: 100 },
      { prop: 'buyAmount', label: '商品总价（元）', minWidth: 100 }
    ],
    span: 24
  },
  { span: 6, type: 'dis-input', prop: 'totalQuantity', label: '商品总数量' },
  { span: 6, type: 'dis-input', prop: 'totalAmount', label: '商品总金额' }
]

// 运单信息
export const BillInfoFormItems = [
  { span: 6, type: 'dis-input', prop: 'waybillNo', label: '运单号' },
  { span: 6, type: 'dis-input', prop: 'expressName', label: '快递公司' },
  {
    span: 6,
    type: 'dis-input',
    label: '门店信息',
    formatter: (data: any, { model }: any) => {
      return (model.shopName || '--') + '(' + (model.shopCode || '--') + ')'
    }
  },
  { span: 6, type: 'dis-input', prop: 'cabinetCode', label: '柜机编号' },
  { span: 6, type: 'dis-input', prop: 'inCabinetSerialNumber', label: '柜机序号' },
  { span: 6, type: 'dis-input', prop: 'cabinetCell', label: '格口位置' }
]

// 支付信息
export const PayInfoFormItems = [
  { span: 6, type: 'dis-input', prop: 'payMethod', label: '支付方式' },
  {
    span: 6,
    type: 'dis-input',
    label: '支付状态',
    formatter: (data: any, { model }: any) => {
      return (PayStatusName as any)[model.payStatus] || '--'
    }
  },
  { span: 6, type: 'dis-input', prop: 'paymentFlowCode', label: '支付流水号' },
  { span: 6, type: 'dis-input', prop: 'payAmount', label: '支付金额' },
  {
    span: 6,
    type: 'dis-input',
    label: '支付时间',
    formatter: (data: any, { model }: any) => {
      return model.payTime ? dayjs(model.payTime).format('YYYY-MM-DD HH:mm:ss') : '--'
    }
  },
  {
    span: 6,
    type: 'dis-input',
    label: '退款状态',
    formatter: (data: any, { model }: any) => {
      return (RefundStatusName as any)[model?.refundOrderStatus] || model?.refundOrderStatus
    }
  }
  // {
  //   span: 6,
  //   type: 'dis-input',
  //   label: '退款状态',
  //   formatter: (data: any, { model }: any) => {
  //     return (RefundStatusName as any)[model.refundOrderStatus] || '--'
  //   }
  // }
  // { span: 6, type: 'dis-input', prop: 'customerTypeName', label: '退款标记人' },
  // {
  //   span: 6,
  //   type: 'dis-input',
  //   label: '退款标记时间',
  //   formatter: (data: any, { model }: any) => {
  //     return model.paySuccessTime ? dayjs(model.paySuccessTime).format('YYYY-MM-DD HH:mm:ss') : '--'
  //   }
  // }
]


// 支付信息
export const RefundInfoFormItems = [
  { span: 6, type: 'dis-input', prop: 'refundAmount', label: '退款金额' },
  {
    span: 6,
    type: 'dis-input',
    label: '退款发起时间',
    formatter: (data: any, { model }: any) => {
      return model?.refundTime ? dayjs(model.refundTime).format('YYYY-MM-DD HH:mm:ss') : '--'
    }
  },
  {
    span: 6,
    type: 'dis-input',
    label: '退款完成时间',
    formatter: (data: any, { model }: any) => {
      return model?.refundSuccessTime ? dayjs(model.refundSuccessTime).format('YYYY-MM-DD HH:mm:ss') : '--'
    }
  },
  // {
  //   span: 6,
  //   type: 'dis-input',
  //   label: '退款状态',
  //   formatter: (data: any, { model }: any) => {
  //     return (RefundStatusName as any)[model?.refundOrderStatus] || model?.refundOrderStatus
  //   }
  // },
  { span: 6, type: 'dis-input', prop: 'creator', label: '退款人' },
  { span: 6, type: 'dis-input', prop: 'refundFlowCode', label: '退款流水号' },
]

